import { useNavigate, useParams } from "react-router-dom";
import { AwsConnectionHelpPane } from "./aws_connection/help_pane";
import { GitRepositoriesHelpPane } from "./git_repo/help_pane";

const HelpMap: Record<
  string,
  React.ComponentType<{ navigateBack: () => void }>
> = {
  aws_connection: AwsConnectionHelpPane,
  git_connections: GitRepositoriesHelpPane,
};

export const QuickLaunchHelpPane = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { deploymentId, serviceType, helpId } = params;
  if (deploymentId === undefined) return null;
  const HelpComponent = HelpMap[helpId!];
  if (HelpComponent === undefined) return null;
  const navigateBack = () => {
    navigate(`/quick_launch/${serviceType}/${deploymentId}`);
  };

  return <HelpComponent navigateBack={navigateBack} />;
};
